import { createStyles } from "@mantine/core"
import { QuorumBlue, LightPurple } from "app/static/frontend/design-constants"

export const useStyles = createStyles(({ isCalculated }) => ({
    statCellScale: {
        height: "1rem",
        width: "calc(100% - 100px)", // keep in px because of safari limitations
        marginBottom: "-0.25rem",
        marginLeft: "1.125rem",
        rect: {
            fill: isCalculated ? LightPurple : Userdata.organization_primary_color || QuorumBlue,
        },
    },
}))
